import { combineReducers } from 'redux'

// user
const userInialState = {
  username: '',
  idHash: '',
  icon: '',
  gender: '',
}

const userReducer = (state = userInialState, action) => {
  return state
}

// roomUsers
const roomUsersInitialState = [
  ['123', 'entropic']
]

const roomUsersReducer = (state = roomUsersInitialState, action) => {
  return state
}

// Room
const roomReducer = (state = '', action) => {
  return 'room_id_hash'
}

// Messsage
const messageInitialState = {
  recipient: undefined,
  type: 'text',
  value: '',
}
const messageReducer = (state = messageInitialState, action)  => {
  switch (action.type) {
    case 'message/setRecipient':
      state = {
        ...state,
        recipient: action.recipient
      }
      break
    default:
      break
  }
  return state
}

// Viewers
const viewersInitialState = {
  viewers: [],
}
const viewersReducer = (state = viewersInitialState, action) => {
  return state
}

// Socket.IO Management
const socketInitialState = {
  connected: false,
  socket: null,
}
const socketReducer = (state = socketInitialState, action) => {
  return state
}

const rootReducer = combineReducers({
  user: userReducer,
  room: roomReducer,
  // maybe put this under room
  roomUsers: roomUsersReducer,
  viewers: viewersReducer,
  socket: socketReducer,

  message: messageReducer,
})

export default rootReducer